import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../mock';

export default function Faq() {
  return (
    <section id="faq" className="relative py-24 lg:py-32 bg-white border-y border-[#e8e4d8]">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <p className="text-xs uppercase tracking-[0.3em] text-[#ea580c] mb-4 font-semibold">FAQ</p>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-[#0b0f0d] leading-tight">
            Straight answers, no agency-speak.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-[#e8e4d8] bg-[#faf9f5] px-6 data-[state=open]:border-[#0b0f0d]/30 data-[state=open]:bg-white"
            >
              <AccordionTrigger className="text-left text-[#0b0f0d] font-display font-semibold text-lg hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#4a4f4c] leading-relaxed pb-5 text-[15px]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
